import { urls, request } from '../utils';
import getHeaders from './getHeaders';

export async function countriesListRequest() {
  return request({
    method: 'get',
    url: urls.countriesList,
    headers: getHeaders(),
  });
}

export async function countriesGroupListRequest() {
  return request({
    method: 'get',
    url: urls.countryGroupList,
    headers: getHeaders(),
  });
}



// WEBPACK FOOTER //
// ./src/services/countries.js